<script setup lang="ts">
import { LucideArrowRight, LucideSparkles } from 'lucide-vue-next'
</script>

<template>
  <section
    class="flex flex-col gap-4 rounded-xl border border-blue-100 bg-blue-50 p-4 sm:flex-row sm:items-center sm:justify-between"
  >
    <div class="flex items-start gap-3">
      <div
        class="flex size-10 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-blue-600 to-purple-600"
      >
        <LucideSparkles class="size-5 text-white" />
      </div>
      <div>
        <Heading tag="h2" class="h6 mb-0">{{ $t('page.deposits_selection.cta_title') }}</Heading>
        <p class="text-sm text-gray-600">{{ $t('page.deposits_selection.cta_text') }}</p>
      </div>
    </div>
    <Button as-child class="w-full shrink-0 sm:w-auto">
      <NuxtLinkLocale to="/deposits/selection">
        <span class="flex items-center justify-center gap-2">
          {{ $t('page.deposits_selection.cta_button') }}
          <LucideArrowRight class="size-4" />
        </span>
      </NuxtLinkLocale>
    </Button>
  </section>
</template>
